const ACTIVITY_PLACE_TENANT_TYPES = {
  NATURAL_PERSON: 'NATURAL_PERSON',
  LEGAL_ENTITY: 'LEGAL_ENTITY',
};

const ACTIVITY_PLACE_TENANT_TYPES_ENUM = Object.keys(ACTIVITY_PLACE_TENANT_TYPES);

export {
  ACTIVITY_PLACE_TENANT_TYPES, ACTIVITY_PLACE_TENANT_TYPES_ENUM,
};
